import React from 'react';

import Modal from "../../../component/modal/ModalTemplate";
import TextInput from "../../../component/input/TextInput";
import { PRIMARY_BTN, SECONDARY_BTN, INPUT, LABEL, FOOTER_CENTER } from "./modalStyle";

interface PhoneRegisterModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    registerAction: () => void;
    setValue: (id: string, value: string) => void;
    phoneName?: string;
    phoneList?: string[];
}

const PHONE_SLOT_COUNT = 10;

const PhoneRegisterModal: React.FC<PhoneRegisterModalProps> = ({
    isOpen, onRequestClose, registerAction, setValue,
    phoneName = "", phoneList = Array(PHONE_SLOT_COUNT).fill(""),
}) => {
    return (
        <Modal
            open={isOpen}
            handleClose={onRequestClose}
            modalTitle="전화번호 등록하기"
            className="react-modal"
        >
            <div className="modal-body tw-max-h-[500px] tw-overflow-y-auto">
                <p className="tw-mb-3 tw-text-xs tw-text-[#FF3D31]">
                    *전화번호 등록 후 모수 추출까지 최대 영업일 기준 3일이 걸릴 수 있습니다.
                </p>
                <div className="tw-mb-3">
                    <label className={LABEL}>전화번호명</label>
                    <TextInput
                        className={INPUT}
                        type="text"
                        id="phoneName"
                        placeholder="특수문자는 입력 불가합니다."
                        value={phoneName}
                        onChange={setValue}
                    />
                </div>
                <div>
                    <label className={LABEL}>등록 전화번호</label>
                    <div className="tw-space-y-2">
                        {Array.from({ length: PHONE_SLOT_COUNT }, (_, index) => (
                            <TextInput
                                key={index}
                                className={INPUT}
                                type="text"
                                id={`phoneNumber${index}`}
                                placeholder="-는 제외하고 입력해 주세요."
                                value={phoneList[index]}
                                onChange={setValue}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div className={FOOTER_CENTER}>
                <button type="button" className={PRIMARY_BTN} onClick={registerAction}>등록</button>
                <button type="button" className={SECONDARY_BTN} onClick={onRequestClose}>취소</button>
            </div>
        </Modal>
    );
};

export default PhoneRegisterModal;
